import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Login failed"));
    }
    setLoading(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0C] px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="card-surface w-full max-w-sm p-8">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-400 text-black">
          <Lock size={20} />
        </span>
        <h1 className="mt-4 text-center font-heading text-2xl font-bold text-white">TrendDrop Owner</h1>
        <p className="mt-1 text-center text-sm text-slate-500">Sign in to your command center</p>
        {error && (
          <p data-testid="admin-login-error" className="mt-4 rounded-lg border border-rose-400/30 bg-rose-400/10 px-3 py-2 text-sm text-rose-300">
            {error}
          </p>
        )}
        <div className="mt-6 space-y-3">
          <input data-testid="admin-email-input" className="input-dark" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="admin-password-input" className="input-dark" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <button data-testid="admin-login-submit" disabled={loading} className="btn-gold mt-6 w-full disabled:opacity-60">
          {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
